const styles = {
    button:{
        width: "21vw",
        marginLeft: "2vw",
        marginRight: "2vw",
        height: "7vh"
    }
}

export default styles;
